<!-- 模块外壳 -->
<template>
    <div class='page_box'>
        <div class="page_left" :style="{width: isPutAway?'0px':'175px',minWidth: isPutAway?'0px':'175px'}">
            <!-- 内部侧边栏 -->
            <el-menu :default-active="actionMenu" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" :unique-opened="true" active-text-color="#ffd04b">
                <el-submenu :index="listValue.jurName" v-for="(listValue,listKey) in menuList" :key="listKey">
                    <template slot="title">
                        <span>{{listValue.jurName}}</span>
                    </template>
                    <el-menu-item-group v-for="(listTwoValue,listTwoKey) in listValue.list" :key="listTwoKey">
                        <el-menu-item :index="listTwoValue.jurHomepage" @click="toPages(listTwoValue)">
                            {{listTwoValue.jurName}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
            <div class="menu-icon" v-if="!isPutAway" @click="isPutAway = true">
                <img src="@/assets/img/home/shouqi.png">
            </div>
        </div>
        <!-- 内容 -->
        <div class="page_right" :style="{paddingLeft: isPutAway?'10px':'0px'}">
            <div class="menu-icon-right" v-if="isPutAway" @click="isPutAway = false">
                <img src="@/assets/img/home/zhankai.png">
            </div>
            <el-tabs v-model="actionMenu" class="index_body_page" type="card" @tab-click="selMenu" @tab-remove="delMenu">
                <el-tab-pane v-loading="flag" element-loading-text="加载中..." class="page_right_tab_content" :closable="menuKey==0 ? false  :  true" v-for="(menuValue,menuKey) in subMenuInfo" :label="menuValue.jurName"
                    :name="menuValue.jurHomepage" :key="menuValue.jurId">
                        <iframe :src="menuValue.jurHomepage" @load="iframeLoad" :ref="menuValue.jurHomepage" class="home_iframe"></iframe>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import $vuex from "../store/index";
// import {mapState, mapActions} from 'vuex'
export default {
    //import引入的组件需要注入到对象中才能使用
    // components: {pageMenu},
    data() {
        //这里存放数据
        return {
            menuList: [],
            subMenuInfo: [],
            showMenu: false,
            isInitPage: false,
            actionMenu: "",
            isPenetrate: false,

            earlyWarningData: "", //接收预警
            isPutAway: false,
            iframeSrc: {
                iframeSrc: ''
            },
            webMenuList: '',
            flag: false
        };
    },
    mounted() {
        window.delMenu = this.delMenu;
        window.toPages = this.toPages;
        window.getMenuInfo = this.getMenuInfo;
        window.getPageMenuList = this.getPageMenuList;
        this.iframeData = this.$route.query;
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        iframeLoad() {
            this.flag = false
        },
        //  单据再现组件 回调isPenetrate参数
        setIsPenetrate(val) {
            this.isPenetrate = val;
        },
        selMenu(e) {
            this.subMenuInfo.forEach((item, keys) => {
                if (item.jurHomepage == e.name) {
                    sessionStorage.removeItem("printJurId");
                    sessionStorage.removeItem("printSource");
                    sessionStorage.removeItem("reportId");
                    sessionStorage.setItem("printJurId", JSON.stringify(item.jurId));
                    sessionStorage.setItem(
                        "printSource",
                        JSON.stringify(item.printSource)
                    );
                    sessionStorage.setItem("reportId", JSON.stringify(item.reportId));
                    this.actionMenu = this.subMenuInfo[keys].jurHomepage;
                }
            });
        },
        // 删除模块菜单
        delMenu(data) {
            var newList = [];
            this.subMenuInfo.forEach((item, keys) => {
                if (item.jurHomepage == data) {
                    if (keys != 0) {
                        sessionStorage.removeItem("printJurId");
                        sessionStorage.removeItem("printSource");
                        sessionStorage.removeItem("reportId");
                        sessionStorage.setItem(
                            "printJurId",
                            JSON.stringify(this.subMenuInfo[keys - 1].jurId)
                        );
                        sessionStorage.setItem(
                            "printSource",
                            JSON.stringify(this.subMenuInfo[keys - 1].printSource)
                        );
                        sessionStorage.setItem(
                            "reportId",
                            JSON.stringify(this.subMenuInfo[keys - 1].reportId)
                        );
                        this.actionMenu = this.subMenuInfo[keys - 1].jurHomepage
                        // this.subMenuInfo.splice(keys - 1,1);
                    }
                } else {
                    newList.push(item);
                }
            });

            this.subMenuInfo = newList;
            // this.actionMenu = this.subMenuInfo[0].jurHomepage
        },
        //删除单据
        delOrder(targetName) {
            var activeOrderId = targetName.split(':')[1]
            this.tabData.forEach((item, i) => {
                if (item.id == activeOrderId) {
                    if (i == 0) {
                        if (this.tabData.length > 1) {
                            this.showTabs = this.tabData[i + 1].titleName
                            this.orderId = this.tabData[i + 1].id
                        } else {
                            this.tabData.splice(i, 1)
                            this.closePage()
                        }
                    } else {
                        this.showTabs = this.tabData[i - 1].titleName
                        this.orderId = this.tabData[i - 1].id
                    }
                    this.tabData.splice(i, 1)
                    this.getData()
                }
            })
            sessionStorage.setItem(
                "tabData", JSON.stringify(this.tabData)
            );
        },
        getMenuInfo(path) {
            var newPageInfo = "";
            var listInfo = this.menuList;
            listInfo.forEach((item) => {
                item.list.forEach((itemList) => {
                    if (itemList.jurHomepage == path) {
                        newPageInfo = itemList;
                    }
                });
            });

            return newPageInfo;
        },
        toPages(pageData) {
            console.log('toPages', pageData);
            console.log('toPages', pageData.jurHomepage);
            // 点击其他页面 关闭穿透组件首页
            this.isPenetrate = false;
            sessionStorage.removeItem("printJurId");
            sessionStorage.removeItem("printSource");
            sessionStorage.removeItem("reportId");
            sessionStorage.setItem("printJurId", JSON.stringify(pageData.jurId));
            sessionStorage.setItem(
                "printSource",
                JSON.stringify(pageData.printSource)
            );
            sessionStorage.setItem("reportId", JSON.stringify(pageData.reportId));

            var saveMenuList = this.subMenuInfo;
            var isMenu = true;
            saveMenuList.forEach((value, keys) => {
                if (value.jurHomepage == pageData.jurHomepage) {
                    isMenu = false;
                }
            });
            if (isMenu == true) {
                this.flag = true
                if (sessionStorage.getItem("loadFlag")) {
                    sessionStorage.removeItem("loadFlag")
                    this.flag = false
                } else {
                    this.flag = true
                }
                this.subMenuInfo.push(pageData);
            }
            this.actionMenu = pageData.jurHomepage;
            var ed = ''
            window.parent.postMessage(
                {
                    //向窗口发送MessageEvent消息
                    cmd: "returnData",
                    params: { ed }, //参数
                },
                "*"
            );
        },
        async getPageMenuList(pageName = "") {
            if (pageName == "") {
                pageName = sessionStorage.getItem("homeActionMenu");
            }
            var menuInfo = await this.$common.getPageMenuListNew(pageName);
            this.menuList = menuInfo.list;
            if (this.iframeSrc.iframeSrc || this.iframeSrc.iframeSrc != '' || this.iframeSrc.iframeSrc.indexOf('\/') != -1) {
                console.log('====', this.iframeSrc.iframeSrc)
                let childData = this.getMenuData(this.iframeSrc.iframeSrc, this.webMenuList, true)
                this.toPages(childData, true);
            }
            else {
                this.toPages(menuInfo.defaultMenu, true);
            }

        },
        //递归查找目录对象
        getMenuData(str, list, type) {
            if (type) {
                for (const v of list || []) {
                    if (v.jurHomepage == str) return v
                    const v_v = this.getMenuData(str, v.list, true)
                    if (v_v) return v_v
                }
            } else {
                for (const v of list || []) {
                    if (v.jurId == str.jurParentid) return v
                    const v_v = this.getMenuData(str, v.list)
                    if (v_v) return v_v
                }
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        if (sessionStorage.getItem('loadFlag')) {
            this.flag = false
        } else {
            this.flag = true
        }
        this.iframeSrc.iframeSrc = window.frameElement.getAttribute('customAttr').replace(/\"/g, "")
        if (this.iframeSrc.iframeSrc || this.iframeSrc.iframeSrc != '' || this.iframeSrc.iframeSrc.indexOf('\/') != -1) { this.webMenuList = this.$store.getters.getMenuList }
        window.getPageMenuList = this.getPageMenuList;
        this.getPageMenuList();
    },

    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { },
};
</script>
<style>
.home_iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: hidden;
    overflow-y: hidden;
    overflow: scroll;
}
.index_body_page {
    height: 100%;
    display: flex;
    -direction: column;
}
.el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 60px;
}
.el-aside {
    color: #333;
}
.el-tabs__header {
    height: 40px;
    margin: 0;
}
/* .el-tabs__active-bar {
} */
.index_body_content {
    height: 99%;
}
.el-tabs__item {
    padding-left: 20px !important;
}
.el-submenu .el-menu-item {
    min-width: 0 !important;
}
.el-menu-vertical-demo {
    height: 100% !important;
}
.menu-icon {
    z-index: 999;
    position: absolute;
    position: fixed;
    left: 154px;
    top: 40%;
    width: 21px;
    height: 76px;
    padding: 3px;
    border: 2px solid #fff;
    border-right: none;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    cursor: pointer;
    background-color: rgb(84, 92, 100);
}
.menu-icon img {
    width: 100%;
    height: 45%;
    margin-top: 18px;
}
.menu-icon-right img {
    width: 100%;
    height: 43%;
    margin-top: 20px;
}
.menu-icon-right {
    z-index: 999;
    left: 0;
    top: 40%;
    position: fixed;
    width: 19px;
    height: 76px;
    padding: 3px;
    background: rgb(84, 92, 100);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    cursor: pointer;
}
.el-submenu__icon-arrow {
    right: 30px !important;
}
/* div::-webkit-scrollbar {
  width: 0;
} */
.page_left::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
.page_left::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #c1c1c1;
}
.page_left::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 1);
    border-radius: 10px;
    background: #f1f1f1;
}
</style>
